import api from '@/api';

const resource = 'gerencial/corteetario';

export default {
  create(data) {
    return api.post(`${resource}`, data);
  },
  get() {
    return api.get(resource);
  },
  save(data) {
    return api.put(`${resource}/${data.identificadorcorteetario}`, data);
  },
  delete(id) {
    return api.delete(`${resource}/${id}`);
  },
};
